import React from "react";
import Divider from "../components/UI/Divider";
import Header from "../components/UI/Header";
import RadioGroup from "../components/UI/RadioGroup";
import FormMandantMorale from "../components/elements/informationsDemandeur/FormMandantMorale";
import FormMandantPhysique from "../components/elements/informationsDemandeur/FormMandantPhysique";
import FormMandataire from "../components/elements/informationsDemandeur/FormMandataire";
import InformationsProprietaire from "../components/elements/informationsDemandeur/InformationsProprietaire";

const InformationsDemandeur = ({
  formData,
  setFormData,
  handleChange,
  handleChangeMandataireConfirm,
  handleChangeMandantConfirm,
  inputFocus,
  handleTrimValue,
  page,
  proprietaireIndivision,
  setProprietaireIndivision,
  proprietairesIndivision,
  setProprietairesIndivision,
}) => {
  return (
    <>
      <Header title="1. Informations sur le demandeur" />
      <section>
        <RadioGroup
          label="Déposez-vous cette demande en tant que mandataire&nbsp;?&nbsp;"
          inputClassName={"page-1-required"}
          name="MandataireOuiNon"
          handleChange={handleChange}
          inputFocus={inputFocus}
          value_1="Oui"
          value_2="Non"
          checked_1={formData?.MandataireOuiNon === "Oui"}
          checked_2={formData?.MandataireOuiNon === "Non"}
          datagroup="mandataire"
        />
        {!formData.MandataireOuiNon || formData?.MandataireOuiNon === "Non" ? (
          <Divider />
        ) : (
          <FormMandataire
            formData={formData}
            setFormData={setFormData}
            handleChange={handleChange}
            inputFocus={inputFocus}
            handleTrimValue={handleTrimValue}
            handleChangeMandataireConfirm={handleChangeMandataireConfirm}
          />
        )}
      </section>
      <section className="mt-5">
        <RadioGroup
          label={
            formData.MandataireOuiNon !== "Oui"
              ? "Vous êtes :"
              : "Vous êtes mandaté(e) par :"
          }
          inputClassName={"page-1-required"}
          name="PersonneType"
          handleChange={handleChange}
          inputFocus={inputFocus}
          value_1="Une personne physique"
          value_2="Une personne morale"
          checked_1={formData?.PersonneType === "Une personne physique"}
          checked_2={formData?.PersonneType === "Une personne morale"}
          datagroup="mandant"
        />
        {formData.PersonneType === "Une personne physique" && (
          <>
            <FormMandantPhysique
              formData={formData}
              handleChange={handleChange}
              inputFocus={inputFocus}
              handleTrimValue={handleTrimValue}
              handleChangeMandantConfirm={handleChangeMandantConfirm}
            />
            <Divider />
            <InformationsProprietaire
              formData={formData}
              setFormData={setFormData}
              proprietaireIndivision={proprietaireIndivision}
              setProprietaireIndivision={setProprietaireIndivision}
              proprietairesIndivision={proprietairesIndivision}
              setProprietairesIndivision={setProprietairesIndivision}
              inputFocus={inputFocus}
              page={page}
            />
          </>
        )}
        {formData.PersonneType === "Une personne morale" && (
          <FormMandantMorale
            formData={formData}
            handleChange={handleChange}
            inputFocus={inputFocus}
            handleTrimValue={handleTrimValue}
            handleChangeMandantConfirm={handleChangeMandantConfirm}
          />
        )}
      </section>
    </>
  );
};

export default InformationsDemandeur;
